<button
  type="button"
  (click)="decrement()"
  [disabled]="value() <= editValues().min || disabled()"
  attr.aria-label="{{ 'addToCart.itemCounter.removeOne' | transloco }}"
>
  -
</button>

<input
  #quantityInput
  type="number"
  [min]="editValues().min"
  [max]="editValues().max"
  [step]="editValues().step"
  [(ngModel)]="value"
  [disabled]="disabled()"
  (blur)="validateInput(quantityInput); quantityChanged.emit(value())"
  attr.aria-label="{{ 'addToCart.itemCounter.quantity' | transloco }}"
/>
<button
  type="button"
  (click)="increment()"
  [disabled]="value() >= editValues().max || disabled()"
  attr.aria-label="{{ 'addToCart.itemCounter.addOneMore' | transloco }}"
>
  +
</button>
